/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Valve_Gateway_DisconnectedInputs */



/**
* | output |
* | --- |
* | "The gateway linked to this valve is disconnected" |
*
* @param {Valve_Gateway_DisconnectedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valve_gateway_disconnected = /** @type {((inputs?: Valve_Gateway_DisconnectedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valve_Gateway_DisconnectedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The gateway linked to this valve is disconnected")
	return /** @type {LocalizedString} */ ("La box liée à cette tête est déconnectée")
});